import { Tenant } from "./tenant";

export class MeasurementType {
  sensor: string;
  unit: string;
  dataType: string;
  tenant: Tenant;

  constructor(sensor?: string, unit?: string, dataType?: string, tenant?: Tenant) {
    this.sensor = sensor;
    this.unit = unit;
    this.dataType = dataType;
    this.tenant = tenant;
  }
}
